<template>
<drawer :opened.sync="opened" @close="onCloseBtnClick">
  <template #header>{{operatorTip}}{{editName}}</template>

  <template #body>
    <el-form ref="form" :model="model" @keydown.native.enter.prevent="onSaveContinueBtnClick">
      <el-row :gutter="gutter">
        <el-col :span="8">
          <el-form-item label="仪器类别" prop="deviceCategoryId">
            <el-select
              v-model="model.deviceCategoryId"
              :disabled="model.id ? true : false"
              filterable
              style="width:100%;"
              @change="onDeviceCategoryChanged"
            >
              <el-option
                v-for="deviceCategory in deviceCategories"
                :key="deviceCategory.id"
                :value="deviceCategory.id"
                :label="deviceCategory.name"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="仪器品牌型号" prop="deviceId">
            <el-select
              v-model="model.deviceId"
              :disabled="model.id ? true : false"
              filterable
              style="width:100%;"
              @change="onDeviceChanged"
            >
              <el-option
                v-for="device in filterDevices"
                :key="device.id"
                :value="device.id"
                :label="`${device.brand + '-' + device.code}`"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="仪器名称">
            <el-input v-model.trim="deviceName" disabled />
          </el-form-item>
        </el-col>
      </el-row>

    <el-row :gutter="gutter">
      <el-col :span="24">
          <el-form-item label="仪器序列号" prop="sn" :rules="[{
            required: true,
            message: '请输入仪器序列号'
          }]">
            <el-input v-model.trim="model.sn" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="gutter">
        <el-col :span="8">
          <el-form-item prop="opsOrgId" label="运维组织">
            <el-select v-model="model.opsOrgId" style="width:100%;">
              <el-option
                v-for="opsOrg in opsOrgs"
                :key="opsOrg.id"
                :value="opsOrg.id"
                :label="opsOrg.name"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item prop="dasId" label="数采来源">
            <el-select v-model="model.dasId" style="width:100%;">
              <el-option
                v-for="das in dasList"
                :key="das.id"
                :value="das.id"
                :label="das.name"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item prop="dataTimeTypeId" label="时间标识">
            <el-select v-model="model.dataTimeTypeId" style="width:100%;">
              <el-option
                v-for="dataTimeType in dataTimeTypes"
                :key="dataTimeType.id"
                :value="dataTimeType.id"
                :label="dataTimeType.name"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="gutter">
        <el-col :span="12">
          <el-form-item label="数据频率(单位: 分钟)" prop="dataFrequency" :rules="[{
            required: true,
            message: '请输入数据频率'
          }]">
            <el-input v-model.trim="model.dataFrequency" :disabled="!isAdmin" type="number" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="设备最大延迟时间(单位: 分钟)" prop="maxDelayTime" :rules="[{
            required: true,
            message: '请输入数据最大延迟时间'
          }]">
            <el-input v-model.trim="model.maxDelayTime" type="number" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="gutter">
        <el-col :span="12">
          <el-form-item label="量程下限" prop="lowRange">
            <el-input v-model.trim="model.lowRange" disabled type="number" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="量程上限" prop="highRange">
            <el-input v-model.trim="model.highRange" disabled type="number" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="gutter">
        <el-col :span="12">
          <el-form-item label="出厂日期" prop="producedDate">
            <el-date-picker
              v-model="model.producedDate"
              type="date"
              format="yyyy年MM月dd日"
              value-format="yyyy/MM/dd"
              :clearable="false"
              :editable="false"
              style="width:100%;"
            />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="使用日期" prop="activatedDate">
            <el-date-picker
              v-model="model.activatedDate"
              type="date"
              format="yyyy年MM月dd日"
              value-format="yyyy/MM/dd"
              :clearable="false"
              :editable="false"
              style="width:100%;"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item
        v-if="isRadarCategory"
        label="探测高度 单位: 千米（每个高度之间以'|'分割）"
        prop="height"
        :rules="[{
          required: true,
          message: '请输入探测高度'
        }, {
          validator: heightValidator,
          trigger: 'change'
        }]"
      >
        <el-input v-model.trim="model.height" />
      </el-form-item>

      <el-form-item label="是否启用" prop="status">
        <el-switch v-model="model.status" />
      </el-form-item>
    </el-form>
  </template>

  <template #footer>
    <el-button type="orange" class="btn save-btn" @click="onSaveBtnClick">保存</el-button>
    <el-button v-if="operator === 1" type="orange" plain class="btn save-continue-btn" @click="onSaveContinueBtnClick">保存并继续</el-button>
    <a class="cancel-btn btn" @click="onCloseBtnClick">关闭</a>
  </template>
</drawer>
</template>

<script>
import BaseEditor from '../../BaseEditor'

export default {
  name: 'SiteDeviceEditor',
  extends: BaseEditor,
  props: {
    siteId: {
      required: true
    },
    opsOrgs: {
      required: true,
      type: Array
    },
    dasList: {
      required: true,
      type: Array
    },
    dataTimeTypes: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      deviceName: ''
    }
  },
  computed: {
    apiKey () {
      return 'SiteDevice'
    },
    idKey () {
      return 'id'
    },
    nameKey () {
      return 'name'
    },
    editName () {
      return '站房仪器'
    },
    isRadarCategory () {
      return this.model.deviceCategoryId & (process.env.LIDAR_DEVICE_CATEGORY | process.env.WIND_PROFILE_CATEGORY)
    },
    filterDevices () {
      return this.deviceCategoryIdMap[this.model.deviceCategoryId]
    }
  },
  methods: {
    initModel () {
      let deviceCategoryId = (this.deviceCategories || [{id: null}])[0].id
      let device = ((this.deviceCategoryIdMap || {})[deviceCategoryId] || [{id: null}])[0]

      return {
        id: null,
        siteId: this.siteId,
        deviceCategoryId,
        deviceId: device.id,
        sn: null,
        opsOrgId: null,
        dasId: null,
        dataTimeTypeId: this.dataTimeTypes[0].id,
        producedDate: new Date().format('YYYY/MM/DD'),
        activatedDate: new Date().format('YYYY/MM/DD'),
        dataFrequency: device.dataFrequency,
        maxDelayTime: device.maxDelayTime,
        lowRange: device.lowRange,
        highRange: device.highRange,
        status: true
      }
    },
    onDeviceCategoryChanged () {
      this.model.deviceId = (this.filterDevices || [{id: null}])[0].id
      this.onDeviceChanged()
    },
    onDeviceChanged () {
      let device = this.deviceMap[this.model.deviceId]
      this.deviceName = device.name
      let {model} = this
      model.dataFrequency = device.dataFrequency
      model.maxDelayTime = device.maxDelayTime
      model.lowRange = device.lowRange
      model.highRange = device.highRange
    },
    heightValidator (rule, value, callback) {
      if (value.split('|').some(num => num === '' || !Number.isFinite(Number(num)))) {
        return callback(new Error('探测高度数据格式不对'))
      }

      callback()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/01Site/SiteDeviceEditor.vue